import React, { useState } from 'react'
import { Alert, Button, Form, Input } from 'antd'
import Authouterpage from '../../components/authouterpages/authouterpage'
import { openNotificationWithIcon } from '../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { userForgotPassword } from '../../api/auth/auth';

const Forgotpassword = () => {
	const [form] = Form.useForm();
	const navigate = useNavigate()

	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<any>(null)
	const [errors, setErrors] = useState({
		email: '',
	})

	const onFinish = async (values: any) => {
		try {
			setLoading(true)
			const res = await userForgotPassword({
				email: values?.email
			})
			const { message } = res.data
			openNotificationWithIcon("success", "Forgot Password", message)
			setLoading(false)
			navigate('/login')
		} catch (error: any) {
			setLoading(false)
			if (error?.response) {
				setError(`${error?.response?.data?.message || 'Something went wrong'}`)
			} else {
				openNotificationWithIcon('error', 'Forgot Password', 'Something went wrong')
			}
		}
	}

	return (
		<Authouterpage
			isPasswordRelated
		>
			<div>
				<div className='mx-auto mt-[6.3rem] bg-appcolorwhite rounded-[20px] w-[40%] custom-box-shadow-seven px-[1.8rem] py-[1.6rem]'>
					<div className='flex border-b border-appcolorgreyfour pb-[1.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Forgot Password</h1>
					</div>

					<div className='mt-[2rem]'>
						{
							error !== null ?
								<div className='mb-4'>
									<Alert message={error} type="error" />
								</div>
								: null
						}

						<Form
							layout="vertical"
							onFinish={onFinish}
							form={form}
						>
							<Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: 'Input is required' },
                { type: 'email', message: 'Email is invalid' }
                ]}
                validateStatus={errors?.email.length > 0 ? 'error' : undefined}
                help={errors?.email.length > 0 ? errors?.email : undefined}
							>
								<Input
									onChange={() => {
										setErrors(prevState => ({
											...prevState,
											email: '',
										}))
									}}
									placeholder="Enter your email"
								/>
							</Form.Item>

							<div className='mt-[2.5rem] flex justify-end'>
								<Button
									disabled={loading}
									className='custom-primary-btn smaller-padding'
									loading={loading}
									htmlType='submit'
								>
									Submit
								</Button>
							</div>
						</Form>
					</div>
				</div>
			</div>
		</Authouterpage>

	)
}

export default Forgotpassword